import React, { forwardRef } from 'react';
import {
  AlertTriangle,
  Archive as ArchiveIcon,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Copy,
  Download,
  FilePen,
  FileText,
  LogIn,
  Plus,
  RefreshCw,
  Search as SearchIcon,
  Tag,
  Trash2,
  X,
} from 'lucide-react';

import { cn } from '@/lib/utils';

const colorClassByProp = {
  action: 'text-slate-500',
  disabled: 'text-slate-300',
  error: 'text-red-500',
  inherit: 'text-current',
  primary: 'text-[#005f98]',
  secondary: 'text-violet-600',
};

const sizeByProp = {
  default: 24,
  inherit: undefined,
  large: 35,
  small: 20,
};

export const createIcon = IconComponent =>
  forwardRef(({ className, color, fontSize = 'default', size, style, ...props }, ref) => {
    const mappedFontSize = sizeByProp[fontSize];
    const styleFontSize = style?.fontSize;
    const resolvedSize = size ?? mappedFontSize ?? styleFontSize ?? sizeByProp.default;
    const finalStyle = {
      width: '1em',
      height: '1em',
      ...(fontSize !== 'inherit' && mappedFontSize ? { fontSize: mappedFontSize } : {}),
      ...style,
    };

    return (
      <IconComponent
        ref={ref}
        size={resolvedSize}
        className={cn(colorClassByProp[color] || 'text-current', className)}
        style={finalStyle}
        {...props}
      />
    );
  });

const Add = createIcon(Plus);
const Archive = createIcon(ArchiveIcon);
const BorderColor = createIcon(FilePen);
const Close = createIcon(X);
const Delete = createIcon(Trash2);
const ExpandLess = createIcon(ChevronUp);
const ExpandMore = createIcon(ChevronDown);
const FileCopy = createIcon(Copy);
const FileDownload = createIcon(Download);
const Input = createIcon(LogIn);
const Label = createIcon(Tag);
const NavigateBefore = createIcon(ChevronLeft);
const NavigateNext = createIcon(ChevronRight);
const PictureAsPdf = createIcon(FileText);
const Refresh = createIcon(RefreshCw);
const ReportProblem = createIcon(AlertTriangle);
const Search = createIcon(SearchIcon);

export {
  Add,
  Archive,
  BorderColor,
  Close,
  Delete,
  ExpandLess,
  ExpandMore,
  FileCopy,
  FileDownload,
  Input,
  Label,
  NavigateBefore,
  NavigateNext,
  PictureAsPdf,
  Refresh,
  ReportProblem,
  Search,
};

export default {
  Add,
  Archive,
  BorderColor,
  Close,
  Delete,
  ExpandLess,
  ExpandMore,
  FileCopy,
  FileDownload,
  Input,
  Label,
  NavigateBefore,
  NavigateNext,
  PictureAsPdf,
  Refresh,
  ReportProblem,
  Search,
};
